/**
 * Twitterウィジェット 外部ファイル
 */
if($('.top-twitter').length > 0){
	window.twttr = (function(d, s, id) {
		var js, fjs = d.getElementsByTagName(s)[0],
		t = window.twttr || {};
		if (d.getElementById(id)) return t;
		js = d.createElement(s);
		js.id = id;
		js.src = "https://platform.twitter.com/widgets.js";
		fjs.parentNode.insertBefore(js, fjs);
		t._e = [];
		t.ready = function(f) {
			t._e.push(f);
		};
		return t;
	}(document, "script", "twitter-wjs"));
}

/**
 * TOPページ　ウィジェット 高さ設定
 */
if($('.top-twitter').length > 0){
	function twitterHeightAlign(widget){
		var w = window.innerWidth,pickUpHeight = 0;
		var widgetElement = $('.top-twitter').find('#' + widget.id).get(0);
		if(w > 767){
			pickUpHeight = $('.top-update-body').innerHeight();
		} else {
			pickUpHeight = $('.top-twitter-body').innerHeight();
		}
		widgetElement.style.height = pickUpHeight + 'px';
	}

	twttr.ready(function (twttr) {
		twttr.events.bind('loaded',function (event) {
			event.widgets.forEach(function (widget) {
				if($('.top-twitter').find('#' + widget.id).length > 0){
					twitterHeightAlign(widget);
					window.addEventListener("resize", function(event) {
						twitterHeightAlign(widget);
					});
				}
			});
		});
	});
}